<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">
    {{ data.cancelText || 'Cancelar' }}
  </button>
  <button
    mat-flat-button
    color="primary"
    data-testid="confirm-dialog-confirm-button"
    (click)="onConfirm()"
    cdkFocusInitial
  >
    {{ data.confirmText || 'Confirmar' }}
  </button>
</mat-dialog-actions>
